export default {
  sm: `
  장경각은 건축재와 환경의 고유한 성질만으로
  팔만대장경을 보존해 온 '에너지 제로' 건물입니다.
  자연 에너지를 활용한 선조들의 지혜는 데이터센터
  각의 친환경적인 지향점에 많은 영감을 주었습니다.
  `,
  lg: `
  장경각은 건축재와 환경의 고유한 성질만으로 팔만대장경을
  보존해 온 '에너지 제로' 건물입니다. 자연 에너지를 활용한
  선조들의 지혜는 데이터센터 각의 친환경적인 지향점에 많은
  영감을 주었습니다.
  `,
  xxl: `
  장경각은 건축재와 환경의 고유한 성질만으로 팔만대장경을 보존해 온
  '에너지 제로' 건물입니다. 자연 에너지를 활용한 선조들의 지혜는
  데이터센터 각의 친환경적인 지향점에 많은 영감을 주었습니다.
  `
};
